import { Injectable } from '@angular/core';
import { Gender } from '@reg/shared/model/gender.model';
import { MultiSelectItem } from '@reg/shared/multi-selection/multi-selection.component';

@Injectable()
export class GenderService {
    public loadMultiSelectGenders(genders?: Gender[] | null): MultiSelectItem[] {
        genders ??= [];

        return [
            new MultiSelectItem(Gender.Male, 'Men/Boys', genders.includes(Gender.Male)),
            new MultiSelectItem(Gender.Female, 'Women/Girls', genders.includes(Gender.Female)),
        ];
    }
}
